import React from "react";
import MainContext from "../../Context/MainContext/MainContext";
import Dialog from "../Dialog";
import MUILoadingButton from "@mui/lab/LoadingButton";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUITextField from "@mui/material/TextField";
import MUIButton from "@mui/material/Button";
import MUIDialogActions from "@mui/material/DialogActions";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker";
import MUITooltip from "@mui/material/Tooltip";

import User from "../../Utility/Crud/User";
import Term from "../../Utility/Crud/Term";
import moment from "moment";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import api from "../../Seating/Security/api";

export default class DialogEvaluationTypeAndDatePicker extends Dialog {
  static contextType = MainContext; // For legacy class components

  async componentDidMount() {
    this.setState({
      date: this.props.row["order_activity.evaluation_date"] || null,
      patientId: this.props.row["order_activity.patient_id"] || null,
    });
    await this.getApproval(
      this.props.row["order_activity.patient_id"],
      this.props.row["order_activity.id"],
    );
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.row !== this.props.row) {
      this.setState({
        date: this.props.row["order_activity.evaluation_date"] || null,
        patientId: this.props.row["order_activity.patient_id"] || null,
      });
      await this.getApproval(
        this.props.row["order_activity.patient_id"],
        this.props.row["order_activity.id"],
      );
    }
  }

  getEvaluationTypeOptions() {
    return Term.sort(Object.values(this.context.termsIndexed))
      .filter((term) => term.type === "evaluation_type")
      .map((term) => ({
        label: term.name,
        value: term.id,
      }));
  }

  async getApproval(patientId, orderId) {
    try {
      const chartData = await api.send("POST", "/chart/get", {
        patientId: patientId,
      });
      const originalOrderActivity = chartData.orderActivity[orderId];
      const orderActivityApprovals = Object.values(
        chartData.orderActivityApprovals,
      ).find(
        (orderActivityApproval) =>
          orderActivityApproval.orderActivityId === orderId,
      );
      const approval = Object.values(chartData?.approval || {}).find(
        (approval) => approval?.id === orderActivityApprovals?.approvalsId,
      );
      this.setState({
        approval: approval,
        originalOrderActivity: originalOrderActivity,
        evaluationTypeTermId: approval?.evaluationTypeTermId,
      });
    } catch (error) {
      console.error(error);
    }
  }

  async updateApproval() {
    try {
      await api.send("POST", "/chart/update", {
        patientId: this.state.patientId,
        returnChart: false,
        updateData: {
          approval: {
            [this.state.approval.id]: {
              evaluationTypeTermId: this.state.evaluationTypeTermId,
              id: this.state.approval.id,
            },
          },
        },
      });
      NotistackEnqueueSnackbar("Changes saved", { variant: "success" });
      this.props.onClose();
    } catch (error) {
      console.error(error);

      if (error?.message?.includes("ORDER_CONFLICT:")) {
        NotistackEnqueueSnackbar(
          "This order was recently updated. Please refresh to see the latest changes.",
          { variant: "warning" },
        );
      } else {
        NotistackEnqueueSnackbar("Error saving changes", { variant: "error" });
      }
    }
  }
  /**
   * Render main content text of dialog
   */
  renderContent() {
    return (
      <>
        <MUITooltip
          title={
            this.state.originalOrderActivity?.isApproved === true
              ? "This order is already approved."
              : !!!this.state.approval
                ? "No approval exists on this order"
                : ""
          }
          placement="bottom-start"
        >
          <span>
            <MUIAutocomplete
              options={this.getEvaluationTypeOptions()}
              value={
                this.getEvaluationTypeOptions().find(
                  (option) => option.value === this.state.evaluationTypeTermId,
                ) || null
              }
              isOptionEqualToValue={(option, value) =>
                option?.value === value?.value
              }
              getOptionLabel={(option) => option?.label || ""}
              onChange={(e, newValue) => {
                if (newValue) {
                  this.setState({ evaluationTypeTermId: newValue.value });
                } else {
                  this.setState({ evaluationTypeTermId: null });
                }
              }}
              sx={{ mt: 2 }}
              disabled={
                this.state.originalOrderActivity?.isApproved === true ||
                !!!this.state.approval
              }
              renderInput={(params) => (
                <MUITextField
                  {...params}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  variant="standard"
                  label="Evaluation Type"
                  fullWidth
                />
              )}
            />
            <MUIDatePicker
              label="Evaluation Date"
              defaultValue={this.state.date ? moment(this.state.date) : null}
              sx={{ mt: 3 }}
              slotProps={{
                field: {
                  clearable: true,
                },
                textField: {
                  fullWidth: true,
                  size: "small",
                  variant: "standard",
                  InputLabelProps: {
                    shrink: true,
                  },
                },
              }}
              disabled={
                this.state.originalOrderActivity?.isApproved === true ||
                !!!this.state.approval
              }
              onChange={(value) => {
                this.setState({ date: value });
              }}
              views={["year", "month", "day"]}
            />
          </span>
        </MUITooltip>
      </>
    );
  }

  /**
   * Render cancel and confirm button actions of dialog.
   */
  renderActions() {
    return (
      <MUIDialogActions spacing={2}>
        <MUIButton variant="text" onClick={this.props.onClose}>
          Cancel
        </MUIButton>
        <MUILoadingButton
          variant="contained"
          loading={this.props.loading}
          onClick={async () => {
            await this.updateApproval();
            this.props.onConfirm(this.state.date);
          }}
        >
          Confirm
        </MUILoadingButton>
      </MUIDialogActions>
    );
  }

  /**
   * @returns {string} The max width of the dialog.
   */
  getMaxWidth() {
    return "xs";
  }

  /**
   * @returns {boolean} Whether or not to make dialog full width.
   */
  getFullWidth() {
    return true;
  }
}
